export default {
  no_documents:
    "You currently don't have any documents. Please check back later or contact support for assistance.",
}
